import React from 'react';

import { Box, Divider, Grid, Typography, useTheme } from '@mui/material';

import { motion } from 'framer-motion';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import StyledIntroduction from './styles';

import logo1 from '../../../assets/images/solution/whitelabel/logo1.png';
import logo10 from '../../../assets/images/solution/whitelabel/logo10.png';
import logo11 from '../../../assets/images/solution/whitelabel/logo11.png';
import logo12 from '../../../assets/images/solution/whitelabel/logo12.png';
import logo2 from '../../../assets/images/solution/whitelabel/logo2.png';
import logo3 from '../../../assets/images/solution/whitelabel/logo3.png';
import logo6 from '../../../assets/images/solution/whitelabel/logo6.png';
import logo7 from '../../../assets/images/solution/whitelabel/logo7.png';
import logo8 from '../../../assets/images/solution/whitelabel/logo8.png';
import logo9 from '../../../assets/images/solution/whitelabel/logo9.png';

const Introduction = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    const whiteLabel = [
        {
            id: 1,
            title: t('igwhitelabel-title-one'),
            content: t('igwhitelabel-content-one'),
            image: logo1,
        },
        {
            id: 2,
            title: t('igwhitelabel-title-two'),
            content: t('igwhitelabel-content-two'),
            image: logo2,
        },
        {
            id: 3,
            title: t('igwhitelabel-title-three'),
            content: t('igwhitelabel-content-three'),
            image: logo3,
        },
        // {
        //     id: 4,
        //     title: '제휴사',
        //     content: '',
        //     image: logo4,
        // },
        // {
        //     id: 5,
        //     title: 'In the case of Betradar',
        //     content: '',
        //     image: logo5,
        // },
        {
            id: 4,
            title: t('igwhitelabel-title-four'),
            content: t('igwhitelabel-content-four'),
            image: logo6,
        },
        {
            id: 5,
            title: t('igwhitelabel-title-five'),
            content: t('igwhitelabel-content-five'),
            image: logo7,
        },
        {
            id: 6,
            title: t('igwhitelabel-title-six'),
            content: t('igwhitelabel-content-six'),
            image: logo8,
        },
        {
            id: 7,
            title: t('igwhitelabel-title-seven'),
            content: t('igwhitelabel-content-seven'),
            image: logo9,
        },
        {
            id: 8,
            title: t('igwhitelabel-title-eight'),
            content: t('igwhitelabel-content-eight'),
            image: logo10,
        },
        {
            id: 9,
            title: t('igwhitelabel-title-nine'),
            content: t('igwhitelabel-content-nine'),
            image: logo11,
        },
        {
            id: 10,
            title: t('igwhitelabel-title-ten'),
            content: t('igwhitelabel-content-ten'),
            image: logo12,
        },
    ];

    return (
        <StyledIntroduction>
            <Box
                sx={{
                    textAlign: { xs: 'center', md: 'center' },
                    zIndex: 1,
                    position: 'relative',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black overlay
                    zIndex: 1,
                    padding: '5% 5% 5% 5%',
                    // backgroundColor: '#fff',
                    background: 'transparent',
                    [theme.breakpoints.down('lg')]: {
                        // mt: 15,
                        mb: -8,
                    },
                }}
            >
                <br /> <br />
                <Divider
                    sx={{
                        backgroundColor: '#21E418',
                        color: '#21E418',
                        width: '133px',
                        height: '8px',
                        justifySelf: 'center',
                        // marginBottom: 10,
                        // marginTop: 5,
                        margin: 'auto',
                    }}
                ></Divider>
                <br /> <br /> <br />
                <Typography
                    variant="h2"
                    component="h2"
                    sx={{
                        fontSize: '40px',
                        fontWeight: '800',
                        lineHeight: '44px',
                        color: '#444444',
                        [theme.breakpoints.down('lg')]: {
                            display: 'none',
                        },
                    }}
                >
                    <motion.div
                        initial={{
                            opacity: 0,
                            y: 100,
                        }}
                        whileInView={{
                            opacity: 1,
                            y: 0, // Slide in to its original position
                            transition: {
                                duration: 1, // Animation duration
                            },
                        }}
                    // viewport={{ once: true }}
                    >
                        {t('igwhitelabel-header-one')}
                    </motion.div>
                </Typography>
                <Typography
                    variant="h2"
                    component="h2"
                    sx={{
                        fontSize: '40px',
                        fontWeight: '800',
                        lineHeight: '47.73px',
                        color: '#444444',
                        display: 'none',
                        [theme.breakpoints.down('lg')]: {
                            display: 'flex',
                            textAlign: 'center',
                            justifyContent: 'center',
                        },
                    }}
                >
                    {t('igwhitelabel-header-one')}
                </Typography>
                <Typography
                    variant="h2"
                    component="h2"
                    sx={{
                        fontSize: '40px',
                        fontWeight: '800',
                        lineHeight: '47.73px',
                        color: '#444444',
                        [theme.breakpoints.down('lg')]: {
                            display: 'none',
                        },
                    }}
                >
                    <motion.div
                        initial={{
                            opacity: 0,
                            y: 100,
                        }}
                        whileInView={{
                            opacity: 1,
                            y: 0, // Slide in to its original position
                            transition: {
                                duration: 1, // Animation duration
                            },
                        }}
                    // viewport={{ once: true }}
                    >
                        {t('igwhitelabel-header-two')}
                    </motion.div>
                </Typography>
                <Typography
                    variant="h2"
                    component="h2"
                    sx={{
                        fontSize: '40px',
                        fontWeight: '800',
                        lineHeight: '44px',
                        color: '#444444',
                        display: 'none',
                        [theme.breakpoints.down('lg')]: {
                            display: 'flex',
                            textAlign: 'center',
                            justifyContent: 'center',
                        },
                    }}
                >
                    {t('igwhitelabel-header-two')}
                </Typography>
                <Box
                    mt={10}
                    mb={10}
                    // px={12}
                    display={'flex'}
                    justifyContent={'center'}
                    sx={{ maxWidth: '100%', maxHeight: '100%', color: '#000000' }}
                >
                    {/* <Grid
            container
            spacing={2}
            sx={{
              display: {
                xs: 'none',
                sm: 'none',
                md: 'none',
                lg: 'flex',
                xl: 'flex',
              },
            }}
          >
            {whiteLabel.map((item, index) => (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                xl={6}
                key={index}
                sx={{
                  justifyItems: 'center',
                }}
              >
                <Box sx={{ maxWidth: '100%', maxHeight: '100%', mt: 5 }} display={'flex'} key={item.id}>
                  <Box
                    sx={{
                      backgroundColor: '#ffffff',
                      textAlign: 'center',
                      maxWidth: '628px',
                      maxHeight: '100%',
                      display: 'flex',
                      justifyContent: 'left',
                      [theme.breakpoints.down('lg')]: {
                        display: 'flex',
                      },
                    }}
                  >
                    <Box
                      px={12}
                      sx={{
                        '& img': {
                          maxWidth: '100%',
                          height: '100%',
                        },
                        [theme.breakpoints.down('lg')]: {
                          px: 0,
                          display: 'flex',
                          justifyContent: 'left',
                          textAlign: 'left',
                          justifySelf: 'left',
                          position: 'absolute',
                          left: 0,
                          '& img': {
                            width: '57px',
                            height: '57px !important',
                            display: 'flex',
                            justifyContent: 'left',
                            textAlign: 'left',
                            justifySelf: 'left',
                          },
                        },
                      }}
                    >
                      <img
                        src={item.image}
                        style={{
                          maxWidth: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        textAlign: 'left',
                        ml: 2,
                        [theme.breakpoints.down('lg')]: {
                          px: 1,
                        },
                      }}
                    >
                      <Box
                        display={'flex'}
                        justifyContent={'center'}
                        sx={{
                          px: 8,
                          [theme.breakpoints.down('lg')]: {
                            px: 1,
                          },
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            mt: 2,
                            mb: 5,
                            lineHeight: '26.67px',
                            wordWrap: 'break-word',
                            fontWeight: 800,
                            fontSize: '21.3px',
                            color: '#676767',
                            [theme.breakpoints.down('lg')]: {
                              mt: 1,
                              fontSize: '21.3px',
                              fontWeight: 700,
                              lineHeight: '25.42px',
                              color: '#444444',
                              textAlign: 'left',
                            },
                          }}
                        >
                          {item.title}
                        </Typography>
                      </Box>
                      <Box px={1}>
                        <Typography
                          variant="body1"
                          sx={{
                            lineHeight: '20px',
                            fontWeight: 600,
                            fontSize: '16px',
                            color: '#676767',
                            [theme.breakpoints.down('lg')]: {
                              fontSize: '16px',
                              lineHeight: '20.8px',
                              textAlign: 'left',
                            },
                          }}
                        >
                          {parse(item.content)}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid> */}
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            display: {
                                xs: 'none',
                                sm: 'none',
                                md: 'none',
                                lg: 'flex',
                                xl: 'flex',
                            },
                        }}
                    >
                        {whiteLabel.map((item, index) => (
                            <Grid
                                container
                                xs={12}
                                sm={12}
                                md={12}
                                lg={6}
                                xl={6}
                                mb={5}
                                key={index}
                                sx={{
                                    justifyItems: 'center',
                                }}
                            >
                                <Grid
                                    item
                                    xs={4}
                                    md={4}
                                    lg={2}
                                    xl={2}
                                    px={12}
                                    sx={{
                                        '& img': {
                                            maxWidth: '52.19px',
                                            height: '52.19px',
                                        },
                                    }}
                                >
                                    <img
                                        src={item.image}
                                        style={{
                                            maxWidth: '52.19px',
                                            height: '52.19px',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={8}
                                    md={8}
                                    lg={8}
                                    xl={8}
                                    justifyContent={'left'}
                                    sx={{
                                        textAlign: 'left',
                                        // ml: 12,
                                        [theme.breakpoints.down('lg')]: {
                                            px: 1,
                                        },
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            mt: 0.5,
                                            mb: 2,
                                            lineHeight: '25.42px',
                                            wordWrap: 'break-word',
                                            fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '900' : '700',
                                            fontSize: '21.3px',
                                            color: '#676767',
                                            [theme.breakpoints.down('lg')]: {
                                                mt: 1,
                                                fontSize: '21.3px',
                                                fontWeight: 700,
                                                lineHeight: '25.42px',
                                                color: '#444444',
                                                textAlign: 'left',
                                            },
                                        }}
                                    >
                                        {item.title}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            lineHeight: '19.09px',
                                            fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                                            fontSize: '16px',
                                            color: '#676767',
                                            [theme.breakpoints.down('lg')]: {
                                                fontSize: '16px',
                                                lineHeight: '20.8px',
                                                textAlign: 'left',
                                            },
                                        }}
                                    >
                                        {parse(item.content)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            display: {
                                xs: 'flex',
                                sm: 'flex',
                                md: 'flex',
                                lg: 'none',
                                xl: 'none',
                            },
                        }}
                    >
                        {whiteLabel.map((item, index) => (
                            <Grid
                                container
                                xs={12}
                                sm={12}
                                md={12}
                                lg={6}
                                xl={6}
                                mb={5}
                                key={index}
                                sx={{
                                    justifyItems: 'center',
                                }}
                            >
                                <Grid
                                    item
                                    xs={4}
                                    md={4}
                                    px={12}
                                    sx={{
                                        '& img': {
                                            maxWidth: '100%',
                                            height: '100%',
                                        },
                                        [theme.breakpoints.down('lg')]: {
                                            px: 0,
                                            display: 'flex',
                                            justifyContent: 'left',
                                            textAlign: 'left',
                                            justifySelf: 'left',
                                            position: 'absolute',
                                            left: 0,
                                            '& img': {
                                                width: '57px',
                                                height: '57px !important',
                                                display: 'flex',
                                                justifyContent: 'left',
                                                textAlign: 'left',
                                                justifySelf: 'left',
                                            },
                                        },
                                    }}
                                >
                                    <img
                                        src={item.image}
                                        style={{
                                            maxWidth: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    xs={8}
                                    md={8}
                                    justifyContent={'left'}
                                    sx={{
                                        textAlign: 'left',
                                        ml: 11,
                                        [theme.breakpoints.down('lg')]: {
                                            // px: 1,
                                        },
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            mt: 2,
                                            mb: 2,
                                            lineHeight: '26.67px',
                                            wordWrap: 'break-word',
                                            fontWeight: 800,
                                            fontSize: '21.3px',
                                            color: '#676767',
                                            [theme.breakpoints.down('lg')]: {
                                                mt: 1,
                                                fontSize: '21.3px',
                                                fontWeight: 800,
                                                lineHeight: '25.42px',
                                                color: '#444444',
                                                textAlign: 'left',
                                            },
                                        }}
                                    >
                                        {item.title}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            lineHeight: '20px',
                                            fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                                            fontSize: '16px',
                                            color: '#676767',
                                            [theme.breakpoints.down('lg')]: {
                                                fontSize: '16px',
                                                lineHeight: '19.09px',
                                                textAlign: 'left',
                                            },
                                        }}
                                    >
                                        {parse(item.content)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>
        </StyledIntroduction>
    );
};

export default Introduction;
